<script setup lang="ts">
import { ref, onMounted, onUnmounted, provide } from 'vue'
import { NConfigProvider, NMessageProvider } from 'naive-ui'

// レスポンシブ対応
const isMobile = ref(window.innerWidth <= 767)
const handleResize = () => {
  isMobile.value = window.innerWidth <= 767
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

// 子コンポーネントで使えるようにprovide
provide('isMobile', isMobile)
</script>

<template>
  <div class="app-wrapper">
    <div class="app-container">
      <n-config-provider>
        <n-message-provider>
          <router-view v-slot="{ Component }">
            <keep-alive :include="['ProductsView']">
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </n-message-provider>
      </n-config-provider>
    </div>
  </div>
</template>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: #f5f5f7;
  min-height: 100vh;
}

#app {
  font-family:
    'Yu Gothic Medium',
    '游ゴシック Medium',
    YuGothic,
    '游ゴシック体',
    -apple-system,
    BlinkMacSystemFont,
    'Hiragino Sans',
    'Hiragino Kaku Gothic ProN',
    meiryo,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-wrapper {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  display: flex;
  justify-content: center;
}

.app-container {
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background-color: white;
  box-shadow: none;
}

/* PC表示時のレイアウト */
@media (min-width: 1200px) {
  .app-container {
    max-width: 1200px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }
}

/* タブレット表示時のレイアウト */
@media (min-width: 768px) and (max-width: 1199px) {
  .app-container {
    max-width: 100%;
  }
}

/* Element Plusのコンテナ共通スタイル */
.el-container {
  height: 100%;
  min-height: 100vh;
  background: white;
}

.el-header {
  padding: 0;
}

.el-main {
  padding: 16px;
  overflow-y: auto;
}

/* モバイルでの左右パディングを小さく */
@media (max-width: 767px) {
  .el-main {
    padding: 16px 8px;
  }
}
</style>
